<template>
  <section class="section">
      <div class="container">
        <h1 class="admin-page">Liquidaciones</h1>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3">
            <div class="box-aside line-top smart-form">
              <div class="box-header-lg">
                <i class="icon-filter"></i><h1> FILTROS</h1>
              </div>
              <div class="box-aside-body box-aside-filters">
                <div class="form-group form-group-full">
                  <label>N° LIQUIDACIÓN</label>
                  <div class="input-group search-box">
                    <input type="text" class="form-control" v-model="filtros.numero" placeholder="Ingresar número">
                    <span class="input-group-btn">
                    <button class="btn btn-default" type="button"><i class="fa fa-search"></i></button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label>DESDE</label>
                  <date-picker v-model="filtros.desde" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter">Quitar filtro fecha</a>
                </div>
                <div class="form-group">
                  <label>HASTA</label>
                  <date-picker v-model="filtros.hasta" :max-date="new Date()"></date-picker>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter">Quitar filtro fecha</a>
                </div>
                <div class="form-group  form-group-full">
                  <label>ESTADO</label>
                  <div class="select">
                  <select v-model="filtros.estado" class="form-control">
                    <option value="-1">Todos</option> 
                    <option value="Cerrado">Cerrada</option> 
                    <option value="Parcial">Parcialmente pagada</option> 
                    <option value="Pagado">Pagada</option> 
                  </select>
                  </div>
                  <!-- agregar class "show" para mostrar el link quitar filtro-->
                  <a href="#" class="disable-filter">Quitar filtro estado</a>
                </div>
                <div class="form-group form-action">
                  <button type="button" @click="apply()" class="btn btn-fill btn-primary btn-block">Filtrar</button>
                </div>
              </div> 
            </div>
            <div class="clear-sm"></div>
            <div class="box-aside line-top smart-form">
              <div class="box-header-lg">
                <i class="icon-stats"></i><h1> RESUMEN</h1>
              </div>
              <div class="box-aside-body resume stats">
                <div class="stats-item">
                  <div class="row">
                    <div class="col-xs-4">
                      <span class="stats-number pending">{{pendientes}}</span>
                    </div>
                    <div class="col-xs-8">
                      <span class="stats-label">Pagos<br/>Pendientes</span>
                    </div>
                  </div>
                </div>
              </div> 
              <div class="box-aside-body resume-total">
                <h3 class="total-number">{{montoACobrar | formatMoneda}}</h3>
                <span class="total-label">Total Adeudado</span>
              </div>

            </div>
            
          </div>
          <div class="col-xs-12 col-sm-12 col-md-8 col-lg-9">
            <div class="box-style line-top smart-form">
              <div class="box-header-lg">
                <h1 class="filter-breadcrumb"> 
                  <span class="semibold">FILTROS</span> 
                    <span v-if="filtros.desde"><i class="fa fa-angle-right"></i> del <span class="regular">{{moment(filtros.desde).format("DD/MM/YYYY")}}</span></span>
                    <span v-if="filtros.hasta"> al <span class="regular">{{moment(filtros.hasta).format("DD/MM/YYYY")}}</span></span>
                    <span v-if="filtros.hasta||filtros.desde">|</span> 
                    <span>
                      Estado: 
                        <span class="regular" v-if="filtros.estado !== '-1'">{{filtros.estado}}</span>
                        <span class="regular" v-else>Todos</span>
                    </span>
                </h1>
                <div class="box-header-aside hide">
                  <a href="#" class="quit-filter"><i class="icon-close"></i> Quitar filtros</a>
                </div>
              </div>
              <div class="panel-body">
                <div class="table-header form smart-form">
                  <div class="form-group col-hactions col3">
                    <label class="label-lg"><i class="icon-export"></i> Descargar</label>
                    <div class="col-action">
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green" @click="exportXls()">
                          EXCEL
                        </button>
                      </div>
                      <div class="btn-group">
                        <button class="btn btn-outline-grey-green" @click="exportPdf()">
                           PDF
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-hactions col5">
                    <button type="button" @click="print()" class="btn btn-fill pull-right" style="margin-top:25px">Imprimir listado</button>
                  </div>
                </div>
                <div class="clear-xs"></div>
                <div class="table-container">
                  <table id="liquidaciones" class="table table-hover table-stripped table-no-first-pad table-manager-time table-liquid">
                    <thead>
                    <tr>
                      <th class="text-right">Liquidación N°</th>
                      <th>Fecha</th>
                      <th class="text-right">Monto bruto</th>
                      <th class="text-right">Comisión (%)</th>
                      <th class="text-right">Monto neto</th>
                      <th>Estado</th>
                      <th class="text-right">Acciones</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr v-for="liquidacion in liquidacionesFiltradas">
                        <td class="text-right">{{liquidacion.numero}}</td>
                        <td>{{liquidacion.fechaCreacion | fechaFormateada}}</td>
                        <td class="text-right">{{liquidacion.montoSinImpuestos | formatMoneda}}</td>
                        <td class="text-right">{{liquidacion.comision}}</td>
                        <td class="text-right">{{liquidacion.montoAPagarAlProveedor | formatMoneda}}</td>
                        <td :class="liquidacion.estado | lower"><span>{{liquidacion.estado}}</span></td>
                        <td>
                          <ul class="table-actions smart-form">
                            <li>
                              <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Exportar en Excel">
                                <i class="fa fa-actions fa-file-excel-o"></i>
                              </a>
                            </li>
                            <li>
                              <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Exportar en PDF">
                                <i class="fa fa-actions fa-file-pdf-o"></i>
                              </a>
                            </li>
                            <li>
                              <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir comanda">
                                <i class="fa fa-actions fa-print"></i>
                              </a>
                            </li>
                            <li>
                              <a href="javascript:void(0)" class="btn btn-xs btn-ghost" type="button" rel="tooltip" data-placement="top" data-original-title="Imprimir etiqueta">
                                <i class="fa fa-actions fa-ticket"></i>
                              </a>
                            </li>
                            <li>
                              <router-link :to="`/restaurante/liquidaciones/${liquidacion._id}`" class="btn btn-xs btn-ghost" type="button">
                                <i class="fa fa-actions fa-eye"></i>
                              </router-link>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hidden" ref="contenedorExport"></div>
  </section>
</template>
<script>
import $ from 'jquery'
import DatePicker from '../Shared/DatePicker'
import moment from 'moment'
import JsPDF from 'jspdf'
import 'jspdf-autotable'
import TableExport from 'tableexport'
import PHE from 'print-html-element'

export default {
  components: {
    'date-picker': DatePicker
  },
  methods: {
    apply () {
      const me = this
      me.$http.post('/api/restaurante/liquidaciones', me.filtros).then(({body}) => {
        me.liquidaciones = body.liquidaciones
      }, (err) => {
        console.error(err)
      })
    },
    print () {
      let tabla = document.getElementById('liquidaciones')
      PHE.printElement(tabla)
    },
    exportXls () {
      const me = this
      let title = 'Liquidaciones '
      if (me.filtros.desde) {
        title += ' desde el ' + moment(me.filtros.desde).format('DD/MM/YYYY')
      }
      if (me.filtros.hasta) {
        title += ' al ' + moment(me.filtros.hasta).format('DD/MM/YYYY')
      }
      if (me.filtros.desde || me.filtros.hasta) {
        title += ' | '
      }
      title += ' Estado: '
      me.filtros.estado === '-1' ? title += 'Todos' : title += me.filtros.estado
      let html = `<table class="table" id="tblExport">
        <thead>
          <tr>
            <th colspan='6'>${title}</th>
          </tr>
          <tr>
            <th>Liquidación N°</th>
            <th>Fecha</th>
            <th>Monto bruto</th>
            <th>Comisión (%)</th>
            <th>Monto neto</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          ${me.liquidacionesFiltradas.map(liq => {
            return `<tr>
              <td>${liq.numero}</td>
              <td>${moment(liq.fechaCreacion).format('DD/MM/YYYY HH:mm')}</td>
              <td>${parseFloat(liq.montoSinImpuestos).toFixed(2)}</td>
              <td>${liq.comision}</td>
              <td>${parseFloat(liq.montoAPagarAlProveedor).toFixed(2)}</td>
              <td>${liq.estado}</td>
            </tr>`
          })
          }
        </tbody>
      </table>`
      $(me.$refs.contenedorExport).html(html)
      let table = document.getElementById('tblExport')
      let tableExp = new TableExport(table, {
        exportButtons: false,
        formats: ['xls', 'csv', 'txt', 'xlsx']
      })
      tableExp.types.date.assert = function (v) {
        return false
      }
      let exportData = tableExp.getExportData()
      console.log('2', exportData)
      tableExp.export2file(exportData.tblExport.xlsx.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'liquidaciones', '.xlsx')
    },
    exportPdf () {
      const me = this
      var img = new Image()
      img.src = '/images/bird.png'
      img.onload = function () {
        let title = 'Liquidaciones '
        if (me.filtros.desde) {
          title += ' desde el ' + moment(me.filtros.desde).format('DD/MM/YYYY')
        }
        if (me.filtros.hasta) {
          title += ' al ' + moment(me.filtros.hasta).format('DD/MM/YYYY')
        }
        if (me.filtros.desde || me.filtros.hasta) {
          title += ' | '
        }
        title += ' Estado: '
        me.filtros.estado === '-1' ? title += 'Todos' : title += me.filtros.estado
        const columns = ['Liquidación N°', 'Fecha', 'Monto bruto', 'Comisión (%)', 'Monto neto', 'Estado']
        const rows = me.liquidacionesFiltradas.map((liq) => {
          return [
            liq.numero,
            moment(liq.fechaCreacion).format('DD/MM/YYYY HH:mm'),
            '$ ' + parseFloat(liq.montoSinImpuestos).toFixed(2),
            liq.comision,
            '$ ' + parseFloat(liq.montoAPagarAlProveedor).toFixed(2),
            liq.estado
          ]
        })
        const doc = new JsPDF('l')
        doc.autoTable(columns, rows, {
          margin: 25,
          bodyStyles: {
            overflow: 'visible',
            fontSize: 8,
            columnWidth: 'wrap'
          },
          headerStyles: {
            fillColor: [147, 165, 18]
          },
          addPageContent: function (data) {
            doc.addImage(img, 'PNG', 25, 10, 12, 12)
            doc.setFontSize(12)
            doc.text(title, 40, 18)
          }
        })
        doc.save('liquidaciones.pdf')
      }
    }
  },
  computed: {
    liquidacionesFiltradas () {
      const me = this
      return me.liquidaciones
    },
    cerradas () {
      let count = 0
      const me = this
      me.liquidacionesFiltradas.map(liq => {
        if (liq.estado.toLowerCase().trim() === 'cerrado') {
          count++
        }
      })
      return count
    },
    pendientes () {
      let count = 0
      const me = this
      me.liquidacionesFiltradas.map(liq => {
        if (liq.estado.toLowerCase().trim() === 'cerrado' || liq.estado.toLowerCase().trim() === 'parcial') {
          count++
        }
      })
      return count
    },
    montoACobrar () {
      let count = 0
      const me = this
      me.liquidacionesFiltradas.map(liq => {
        if (liq.estado.toLowerCase().trim() === 'cerrado' || liq.estado.toLowerCase().trim() === 'parcial') {
          count += liq.montoAPagarAlProveedor
        }
      })
      return count
    }
  },
  data () {
    return {
      liquidaciones: [],
      filtros: {
        desde: null,
        hasta: null,
        numero: '',
        estado: '-1'
      }
    }
  },
  filters: {
    fechaFormateada (value) {
      return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
    },
    formatMoneda (value) {
      return '$ ' + parseFloat(value).toFixed(2)
    },
    lower (value) {
      return `status-${value.trim().toLowerCase()}`
    }
  },
  mounted () {
    const me = this
    $('body').addClass('admin')
    me.moment = moment
    let filters = {desde: moment().add(-180, 'days').toDate(), hasta: new Date()}
    me.$http.post('/api/restaurante/liquidaciones', filters).then(({body}) => {
      me.liquidaciones = body.liquidaciones
    }, (err) => {
      console.error(err)
    })
  }
}
</script>
<style scoped>
.status-generado {
  background-color: #fbf7ad;
}
.status-cerrado {
  background-color: #dd6262;
  color: #f0f0f0;
}
.status-pagado {
  background-color: #99be8f;
  color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// Liquidaciones.vue?d217e23a